module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day03_01_stay-041c914e7366580a6e741dcda8514d50.jpg";